module.exports = __webpack_public_path__ + "static/media/24UHCHR24.61100071.jpg";